/* eslint formatjs/no-literal-string-in-jsx: "error" */
import { useFormContext } from "react-hook-form"
import { PhoneCodes } from "content/PhoneCodes"
import { CompleteFormSelect } from "components/views/atoms/forms/FormSelect"
import { CompletePrefixInput } from "components/views/atoms/forms/FormPrefixInput"
import React from "react"
import { useIntl } from "react-intl"
import { CountryCode, CountryCodes } from "content/CountryMap"
import { useIntlSort } from "utils/hooks/useIntlSort"

const CountryCodeAndPhoneNumberInputs = ({ onChange }) => {
  const {
    register,
    formState: { errors },
    watch
  } = useFormContext()
  const countryCode = watch("countryCode")
  const phoneCode = PhoneCodes[countryCode]
  const intl = useIntl()
  const { localeComparator } = useIntlSort()

  const PhoneCodeSelectOptions: Array<{ id: CountryCode; label: string }> = CountryCodes.map((countryCode) => {
    const formattedCountryCode = intl.formatDisplayName(countryCode, { type: "region" })
    return {
      id: countryCode,
      label: intl.formatMessage(
        { defaultMessage: "{countryCode} (+{phoneCode})" },
        { countryCode: formattedCountryCode, phoneCode: PhoneCodes[countryCode] }
      )
    }
  }).sort((a, b) => localeComparator(a.label, b.label))

  return (
    <>
      <CompleteFormSelect
        {...register("countryCode")}
        onChange={onChange}
        label={intl.formatMessage({ defaultMessage: "country code" })}
        options={PhoneCodeSelectOptions}
      />
      <CompletePrefixInput
        onChange={onChange}
        {...register("phoneNumber", {
          required: intl.formatMessage({ defaultMessage: "Please enter a valid phone number" })
        })}
        errors={errors}
        label={intl.formatMessage({ defaultMessage: "phone number" })}
        prefixText={phoneCode ? `+${phoneCode}` : ""}
        showValidation
      />
    </>
  )
}

export { CountryCodeAndPhoneNumberInputs }
